<template>
  <div :class="[wrapperClass, error ? 'error' : '']" class="form_field input-with-btn w-100">
    <label v-if="label" :for="uniqueId" class="form_label">
      {{ label }}
    </label>
    <div class="form_field">
      <input
          :id="uniqueId"
          v-model="model"
          :class="{
            'with-icon': showSearchIcon || !!slots.icon
          }"
          :maxlength="attrs.maxlength"
          :placeholder="placeholder ||`${$t('search_item')}...`"
          autocomplete="off"
          class="form_input"
          type="text"
          v-bind="attrs"
      >
      <slot name="icon">
        <label v-if="showSearchIcon" :for="uniqueId">
          <i v-if="!loading" class="icon i-search f18 wh43" />
          <span v-else class="icon f fc wh43"><i class="i-loading" /></span>
        </label>
      </slot>

      <button
          v-if="model"
          class="btn wh43 btn_clear input_btn"
          type="button"
          @click="model = ''"
          @click.stop
      >
        <i class="i-times f14"></i>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const model = defineModel()
const slots = useSlots();
const attrs = useAttrs();
defineOptions({
  inheritAttrs: false
})
const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  showSearchIcon: {
    type: Boolean,
    default: false
  },
  wrapperClass: {
    type: String,
    default: ''
  },
  error: {
    type: Boolean,
    default: false
  },
})

const uniqueId = useId();

</script>

<style lang="scss" scoped>

</style>
